export default __webpack_public_path__ + "static/media/me.e3aa4a41.jpg";